module.exports = __webpack_public_path__ + "img/06 - Condominio_das_Americas_Guarita.932f44a3.jpg";